import io from 'socket.io-client';
import { DEPLOYENVIRONMENT, PRESENCE_PORT } from 'apiConfig';

export const socket = io(`wss://${DEPLOYENVIRONMENT}socket.garlicerp.com:${PRESENCE_PORT}`, {
	transports: ['websocket', 'webtransport'],
	autoConnect: true,
	reconnection: true,
	reconnectionAttempts: Infinity,
	reconnectionDelay: 1000,
	reconnectionDelayMax: 10000,
	timeout: 20000,
});

if (process.env.NODE_ENV === 'development') {
	socket.on('connect', () => {
		console.log('[socket] connect', {
			id: socket.id,
			connected: socket.connected,
		});
	});

	socket.on('disconnect', (reason) => {
		console.log('[socket] disconnect', {
			reason,
			connected: socket.connected,
		});
	});

	socket.on('connect_error', (error) => {
		console.log('[socket] connect_error', error?.message || error);
	});

	socket.io.on('reconnect_attempt', (attempt) => {
		console.log('[socket] reconnect_attempt', attempt);
	});

	socket.io.on('reconnect', (attempt) => {
		console.log('[socket] reconnect success', {
			attempt,
			id: socket.id,
			connected: socket.connected,
		});
	});

	socket.io.on('reconnect_error', (error) => {
		console.log('[socket] reconnect_error', error?.message || error);
	});

	socket.io.on('reconnect_failed', () => {
		console.log('[socket] reconnect_failed');
	});
}
